import React, { useEffect, useRef } from "react";
import { CardLabel } from "@src/components/card_label/index";
import { ProjectPhaseChip } from "@src/components/project_phase_chip/index";
import Status from "@src/components/status/status";
import { RequestOverviewDetails } from "@src/types";
import { formatDate, getWorkloadStartDate } from "@src/utils/helper";
import { Card, Flex, Row, Col } from "antd";
import "./project_information_card.less";

import Technologies from "../../../../components/technologies/technologies";

interface ProjectInformationCardProps {
  request: RequestOverviewDetails;
}

const ProjectInformationCard: React.FC<ProjectInformationCardProps> = ({
  request,
}) => {
  const requestRef = useRef<RequestOverviewDetails>(request);
  const currentRequest = requestRef.current;

  useEffect(() => {
    requestRef.current = request;
  }, [request]);

  return (
    <Card
      title={currentRequest.projectName}
      className="info-card"
      data-testId="project-information-card"
    >
      <Row gutter={[10, 0]}>
        {/*left side*/}
        <Col span={12}>
          <Flex vertical gap={10}>
            <CardLabel label="Phase" showToolTip={false}>
              {" "}
              <ProjectPhaseChip
                projectPhase={currentRequest.projectPhase}
                compact={false}
              />
              {currentRequest.stageGateDate && (
                <span>{`(End: ${formatDate(
                  currentRequest.stageGateDate
                )})`}</span>
              )}
            </CardLabel>
            <CardLabel label="Status">
              <Status
                status={
                  currentRequest?.childRequest?.status ?? currentRequest?.status
                }
              />
            </CardLabel>
            <CardLabel label="Project Lead">
              {currentRequest.projectLead}
            </CardLabel>
          </Flex>
        </Col>

        {/*right side*/}
        <Col span={12}>
          <Flex vertical gap={10}>
            <CardLabel label="Region / Country">
              {currentRequest.region || "N.A."} / {currentRequest.country}
            </CardLabel>
            <CardLabel label="Technology" showToolTip={false}>
              <Technologies technologies={currentRequest.technologies} />
            </CardLabel>

            <CardLabel label="Workload Start" showToolTip={false}>
              {getWorkloadStartDate(currentRequest)}
            </CardLabel>
          </Flex>
        </Col>
      </Row>
    </Card>
  );
};

export default ProjectInformationCard;
